const useArticleModalStatusActions = ({
  onToggleFavorite,
  onToggleRead,
  setLocalArticle
}) => {
  const handleToggleFavorite = async (articleId) => {
    try {
      setLocalArticle(prev => ({
        ...prev,
        isFavorite: !prev.isFavorite
      }));

      if (onToggleFavorite) {
        await onToggleFavorite(articleId);
      }
    } catch (error) {
      console.error('Erro ao alternar favorito:', error);
      setLocalArticle(prev => ({
        ...prev,
        isFavorite: !prev.isFavorite
      }));
    }
  };

  const handleToggleRead = async (articleId) => {
    try {
      setLocalArticle(prev => ({
        ...prev,
        isRead: !prev.isRead
      }));

      if (onToggleRead) {
        await onToggleRead(articleId);
      }
    } catch (error) {
      setLocalArticle(prev => ({
        ...prev,
        isRead: !prev.isRead
      }));
      console.error('Erro ao alternar lido:', error);
    }
  };

  return {
    handleToggleFavorite,
    handleToggleRead
  };
};

export default useArticleModalStatusActions;
